import React, { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import { REGEXPS, VALIDATORS } from '@/common';
import Label from '@/components/elements/Label';
import theme from '@/styles/theme';

import { BillingMethod } from '../AccountFunding.types';
import FinancialHeader from '../FinancialHeader';
import { useAccountFundingParamsStore } from '../stores';

const HOLD_PERIOD_DESCRIPTION = `The number of days contributions or other credits from an employees personal bank account
, such as repayments, will pend on the account before becoming available for spend.`;
const GIVE_UP_DAYS_DESCRIPTION = `Failure to receive funds after the give up period has
 passed will result in the contributions being reversed from the participants account.`;

interface Props {
  isLastSection?: boolean
}

export const usePayrollContributionFields = (props?: Props, isActivationMode?: boolean) => {
  const billingMethodTypeId = useAccountFundingParamsStore((state) => state.state.billingMethodTypeId);
  
  const payrollContributionFields = useMemo(() => {
    return [
      {
        name: 'financeTitle',
        type: FieldTypes.Node,
        fieldWrapperStyles: {
        borderTop: `1px solid ${theme.colors.border1}`,
        paddingTop: theme.spacings.m,
        },
        value: (
        <FinancialHeader
          title="Payroll Contribution"
          subTitle="Elevate collects contributions made to employee-owned accounts, such as an HSA, prior to posting to the employee's account"
        />
        ),
      }, 
      ...billingMethodTypeId === BillingMethod.PULL ? [{
        name: 'contributionHoldPeriod',
        type: FieldTypes.Number,
        label: <Label title="Hold period" desc={HOLD_PERIOD_DESCRIPTION} />,
        regexp: REGEXPS.ONLY_NUMBERS,
        placeholder: 'Enter # of days',
        showRequireIcon: true,        
        fieldWrapperStyles: {
          borderBottom: props?.isLastSection ? `1px solid ${theme.colors.border1}` : undefined,
          paddingBottom: theme.spacings.m,
        },
        validator: isActivationMode ? VALIDATORS.REQUIRED_POSITIVE_NUMBER_ONLY : undefined,
      }] : [{
        name: 'contributionPushGiveUpDays',
        type: FieldTypes.Number,
        label: <Label title="Give up period (days)" desc={GIVE_UP_DAYS_DESCRIPTION} />,
        regexp: REGEXPS.ONLY_NUMBERS,
        placeholder: 'Enter # of days',
        showRequireIcon: true,
        fieldWrapperStyles: {
          borderBottom: props?.isLastSection ? `1px solid ${theme.colors.border1}` : undefined,
          paddingBottom: theme.spacings.m,
        },
        validator: isActivationMode ? VALIDATORS.REQUIRED_POSITIVE_NUMBER_ONLY : undefined,
      }]
    ] as Field[];
  }, [props, billingMethodTypeId, isActivationMode]);
  return payrollContributionFields;
};
